<div class="loader tw-relative tw-h-full tw-w-full">
  <div class="spinner"></div>
</div>
